import React from 'react';
import { Box, darken, withStyles } from '@material-ui/core';
import { red, alert } from 'globals/colors';
import { centerBoxProps } from 'globals/utils';
import FsBody from 'ui-elements/typography/FsBody';
import FsButton from 'ui-elements/buttons/FsButton';
import { FsButtonProps } from 'ui-elements/buttons/FsButton/FsButton';

export const WrapperBox = withStyles(({ spacing, breakpoints }) => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: red.V4,
    borderTop: `1px solid ${alert.ERROR}`,
    zIndex: 11,
    padding: spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    [breakpoints.up('md')]: {
      bottom: 'auto',
      top: 0,
      borderBottom: `1px solid ${alert.ERROR}`,
      borderTop: 0,
    },
  },
}))(Box);

export const ContentBox = withStyles(() => ({
  root: {
    ...centerBoxProps,
  },
}))(Box);

export const Info = withStyles(() => ({
  root: {
    color: alert.ERROR,
  },
}))(FsBody);

export const Button = withStyles(({ palette }) => ({
  root: {
    color: palette.common.white,
    backgroundColor: alert.ERROR,
    '&:hover': {
      backgroundColor: darken(alert.ERROR, 0.1),
    },
  },
}))((props: FsButtonProps) => <FsButton {...props} />);
